import React from "react"
import { FooterWithCTA, SEO, Layout } from "@components"
import { Hero } from "@components"
import Content from "@components/pages/tools/Content.js"
import { webPageSchema, breadcrumbSchema, HOME_CRUMB } from "@utils/schema"

const TITLE = "DynamoDB Tools: GUIs, Libraries and Local Development"
const DESCRIPTION =
  "Compare DynamoDB GUIs, local development tools, infrastructure tools and data mappers, including DynamoDB Toolbox, ElectroDB and PynamoDB."

const ToolsPage = () => {
  return (
    <>
      <Layout>
        <SEO
          title={TITLE}
          description={DESCRIPTION}
          canonical="https://dynobase.dev/dynamodb-tools/"
          jsonLd={[
            webPageSchema({
              name: TITLE,
              description: DESCRIPTION,
              path: "/dynamodb-tools/",
            }),
            breadcrumbSchema([HOME_CRUMB, { name: "DynamoDB Tools" }]),
          ]}
        />
        <Hero title={"DynamoDB tools for development and operations"} />
        <Content />
        <FooterWithCTA />
      </Layout>
    </>
  )
}

export default ToolsPage
